import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Modal } from 'semantic-ui-react';
import { clientErrors, firstResponseError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import DialogWrapper from '@/components/dialogs/DialogWrapper';
import { hideDatasetCondition, updateActiveDatasetConditionProperties } from '../actions';
import DatasetConditionForm from './DatasetConditionForm';
import { datasetPerms } from '../../sharing/state/state';
import { datasetPermissions } from '../../sharing/constants';
import DatasetConditionDialogActions from './DatasetConditionDialogActions';

const DatasetConditionDialog = ({
  hide,
  isNew,
  saveErrors,
  theme,
  updateProperties,
}) => {
  const intl = useIntl();
  return (
    <DialogWrapper
      className="aridhia-dataset-condition-dialog smallwizard"
      error={firstResponseError(saveErrors)}
      onClose={hide}
      onDismiss={() => updateProperties({ saveErrors: clientErrors(saveErrors) })}
      size="small"
      theme={theme}
      title={intl.formatMessage({ id: isNew ? 'dataset.condition.add.title' : 'dataset.condition.edit.title' })}
    >
      <Modal.Content scrolling><DatasetConditionForm /></Modal.Content>
      <DatasetConditionDialogActions />
    </DialogWrapper>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { datasets: { update } } } },
  datasetConditions: {
    activeCondition: {
      category, code, isNew, saveErrors,
    },
  },
  datasetUsers: { permissions },
}) => {
  const permission = findResult(permissions, category, code) || datasetPerms();

  return ({
    canEdit: update && permission[datasetPermissions.CONDITIONS],
    isNew,
    saveErrors,
  });
};

const mapDispatchToProps = {
  hide: hideDatasetCondition,
  updateProperties: updateActiveDatasetConditionProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetConditionDialog);
